import React from 'react';

interface FiltroPillProps {
  label: string;
  children: React.ReactNode;
}

/**
 * Wrapper visual para um filtro tipo "chip" (select ou input) usado em barras de filtro
 * horizontais. Mantém o rótulo do filtro sempre visível, mesmo quando um valor já está
 * selecionado, evitando que o usuário precise abrir o filtro para saber o que ele representa.
 */
const FiltroPill: React.FC<FiltroPillProps> = ({label, children}) => (
  <div className="flex items-center gap-1 rounded-full border border-gray-300 text-sm min-w-max pl-3 pr-1 whitespace-nowrap">
    <span className="text-gray-500">{label}:</span>
    {children}
  </div>
);

export default FiltroPill;
